var map = {
	".": 28,
	"./": 28,
	"./card": 35,
	"./card.composition": 84,
	"./card.composition.js": 84,
	"./card.composition.js.map": 146,
	"./card.docs.mdx": 147,
	"./card.js": 35,
	"./card.js.map": 148,
	"./card.module.scss": 62,
	"./card.spec": 85,
	"./card.spec.js": 85,
	"./card.spec.js.map": 149,
	"./index": 28,
	"./index.js": 28,
	"./index.js.map": 150,
	"./static/Notera.ttf": 151,
	"./static/contactless.png": 64,
	"./static/cratio.png": 63,
	"./static/fidize.png": 152,
	"./static/lratio.png": 65,
	"./static/qr.png": 66,
	"./static/templates/1.png": 69,
	"./static/templates/10.png": 78,
	"./static/templates/11.png": 82,
	"./static/templates/12.png": 83,
	"./static/templates/2.png": 70,
	"./static/templates/3.png": 71,
	"./static/templates/4.png": 72,
	"./static/templates/5.png": 73,
	"./static/templates/6.png": 74,
	"./static/templates/7.png": 75,
	"./static/templates/8.png": 76,
	"./static/templates/color1.png": 77,
	"./static/templates/color2.png": 79,
	"./static/templates/color3.png": 80,
	"./static/templates/color4.png": 81,
	"./static/templates/colored.png": 86,
	"./static/your_logo.png": 153,
	"./static/your_logo_color.png": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145;